<main class="aic-landing position-relative overflow-hidden flex-fill d-flex">
  <section class="position-relative overflow-hidden flex-fill d-flex align-items-center">
    <div class="aic-hero-glow aic-hero-glow-one position-absolute rounded-circle pe-none d-none" aria-hidden="true"></div>
    <div class="aic-hero-glow aic-hero-glow-two position-absolute rounded-circle pe-none d-none" aria-hidden="true"></div>

    <div class="container position-relative d-flex align-items-center justify-content-center pt-2 pb-4">
      <div class="d-flex flex-column align-items-center text-center">
        <div class="aic-hero-orb-wrap position-relative mt-3 mb-5">
          <div class="aic-hero-ring aic-hero-ring-outer position-absolute rounded-circle pe-none" aria-hidden="true"></div>
          <div class="aic-hero-ring aic-hero-ring-mid position-absolute rounded-circle pe-none" aria-hidden="true"></div>

          <router-link
            to="/login"
            class="aic-hero-orb aic-hero-orb-action position-absolute rounded-circle d-flex align-items-center justify-content-center"
            aria-label="Enter the platform"
          >
            <span class="aic-hero-orb-mark d-block"></span>
            <span class="aic-hero-orb-cta position-absolute d-flex flex-column align-items-center justify-content-center rounded-circle">
              <i class="bi bi-arrow-right fs-4"></i>
              <span class="aic-hero-orb-cta-text text-uppercase">Enter</span>
            </span>
          </router-link>

          <div
            v-for="(card, idx) in hero_cards"
            :key="card.key"
            class="aic-hero-badge position-absolute d-none d-lg-flex align-items-center gap-2 border border-dark bg-white text-dark shadow p-2 rounded-4"
            :class="'aic-hero-badge-pos-' + (idx + 1)"
            :style="{ animationDelay: (idx * 0.12 + 0.5) + 's' }"
          >
            <i class="text-danger fs-5 lh-1" :class="card.icon"></i>
            <div class="text-start">
              <span class="d-block fw-bold small text-dark">{{ card.label }}</span>
              <span class="d-block small text-secondary">{{ card.description }}</span>
            </div>
          </div>
        </div>

        <h1 class="visually-hidden">AI that watches every property, so you don't have to.</h1>

        <p class="aic-hero-arc-fallback d-md-none fw-bold mb-0" aria-hidden="true">
          AI that watches every property, so you don't have to.
        </p>

        <svg class="aic-hero-arc d-none d-md-block" viewBox="0 0 1200 300" aria-hidden="true">
          <path id="heroArcPath" d="M 30 88 Q 600 218 1170 88" fill="none"></path>
          <text class="aic-hero-arc-text">
            <textPath href="#heroArcPath" startOffset="50%" text-anchor="middle" textLength="1080" lengthAdjust="spacingAndGlyphs">AI that watches every property, so you don't have to.</textPath>
          </text>
        </svg>

      </div>
    </div>
  </section>
</main>
